import styled from 'styled-components/macro'
import { theme } from './index'

/* PUBLIC PAGES */
export const PublicPageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100vh;
`
export const PublicContentWrapper = styled.main`
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  overflow: auto;

  /* Centers short pages vertically. Unlike justify-content: center, tall content
     isn't pushed above the scroll origin, so its top stays reachable. */
  &::before,
  &::after {
    content: '';
    margin: auto;
  }
`

/* PROTECTED PAGES */
export const ProtectedPageWrapper = styled.div`
  display: flex;
  height: 100vh;
`
export const ProtectedContentParent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
`
export const ProtectedContentWrapper = styled.div`
  flex: 1;
  overflow: auto;
`

/* STATIC PAGES */
// eslint-disable-next-line space-in-parens
export const StaticPageWrapper = styled.main`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-flow: column nowrap;
  overflow: auto;
`
